export enum Plan {
  SILVER = 'silver',
  GOLD = 'gold'
}
